import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { z } from "zod";
import { Blade } from "../../../../../components/Blade";
import { ConsoleButtons } from "../../../components/ConsoleButtons";
import { BetaMastheadModal } from "../../../components/BetaMastheadModal";
import { Lightbox } from "../../../../../components/Lightbox";
import { BetaMasthead } from "../../../components/BetaMasthead";
import { usePageMetadata } from "../../../../../context/PageMetadata";
import { ConsoleType } from "../../../functional/utils";
import { fetchData } from "../../../api/api";
import { generateEndpointsByID } from "../../../api/types/endpoints";
import { UserStatus } from "../../../api/types/enums";
import { useBetaHubRouter } from "../../../functional/hooks/useBetaHubRouter";
import { BetaRegistrationMastheadBladeSchema, } from "../../../schemas/BetaRegistrationMasthead";
import { BetaLoader } from "../../../components/BetaLoader";
import { getErrorPageRoute, getExpectedBetaPath } from "../../../functional/getExpectedBetaPath";
import { BETA_BASE_ROUTE } from "../../../functional/constants";
import { monitoring } from "../../../functional/monitoring";
export const BetaConnectConsoleMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal("betaConnectConsoleMasthead"),
});
const xboxPlatform = "XBOX";
const _BetaConnectConsoleMasthead = ({ header, backdrop, className, gameIcon, buttons, psRegionModal, campaignID, forceRegionModal = false, ...bladeProps }) => {
    const { locale, environment } = usePageMetadata();
    const { isLoading, isFullScreen, isAllowedRoute, inviteCode } = useBetaHubRouter({ campaignID });
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [showRegionModal, setShowRegionModal] = useState(forceRegionModal);
    const getKeys = useCallback(async (region) => {
        const betaBaseRoute = `${BETA_BASE_ROUTE}/${locale}`;
        try {
            const { hostname } = window.location;
            const { BETA_KEY_ENDPOINT } = generateEndpointsByID({ campaignID, environment, hostname });
            setIsPageLoading(true);
            await fetchData({
                endpoint: BETA_KEY_ENDPOINT,
                method: "POST",
                body: { fpab_platform: region },
            });
            const newPath = getExpectedBetaPath({
                userStatus: UserStatus.Completed,
                currentPath: "",
                hasInviteCode: !!inviteCode,
                campaignID,
            });
            window.location.href = `${betaBaseRoute}${newPath}`;
        }
        catch (error) {
            monitoring.logError(error, "Error fetching beta keys (possibly duplicate error)");
            setIsPageLoading(false);
            const errorPage = getErrorPageRoute(error instanceof Error ? error.message : "");
            window.location.href = `${betaBaseRoute}${errorPage}`;
        }
    }, [environment, locale, campaignID, inviteCode]);
    const onButtonClick = (method) => {
        if (method === ConsoleType.PLAYSTATION) {
            setShowRegionModal(true);
        }
        else if (method === ConsoleType.XBOX) {
            getKeys(xboxPlatform);
        }
    };
    const onClickPsModalContinue = async (region) => {
        if (!region) {
            throw new Error("No Region Provided to generate PS Key");
        }
        else {
            getKeys(region);
            setShowRegionModal(false);
        }
    };
    return (React.createElement(BetaLoader, { isLoading: isLoading || isPageLoading, isAllowedRoute: isAllowedRoute, palette: "palette3" },
        React.createElement(Blade, { "data-testid": "BetaConnectConsoleMasthead", className: className, ...bladeProps },
            React.createElement(BetaMasthead, { header: header, backdrop: backdrop, gameIcon: gameIcon, isFullHeight: isFullScreen, ...bladeProps },
                React.createElement(ConsoleButtons, { buttons: buttons, onButtonClick: onButtonClick }),
                React.createElement(Lightbox, { visible: showRegionModal, onChange: () => setShowRegionModal(false) },
                    React.createElement(BetaMastheadModal, { ...psRegionModal, firstModalButtonCustomAction: () => setShowRegionModal(false), secondModalButtonCustomAction: onClickPsModalContinue }))))));
};
export const BetaConnectConsoleMasthead = styled(_BetaConnectConsoleMasthead) `
  & ${ConsoleButtons} {
    margin-top: 16px;
  }
`;
//# sourceMappingURL=BetaConnectConsoleMasthead.js.map